import _ from 'lodash'

import { FETCH_DESTINATIONS_SUCCESS } from '../actions/fetchTours'

const initialState = {}

export default function fetchDestinations(state = initialState, action) {
  switch (action.type) {
    case FETCH_DESTINATIONS_SUCCESS:
      return action.payload
    default:
      return state
  }
}

export const getDestinationsData = state => _.get(state, 'destinationsData')
